var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatYouGet4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_431_10770)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#AF1F49"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_10770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5362 14.4561H24.7838C19.0263 14.4561 14.3438 19.1411 14.3438 24.8986V83.6423C14.3438 89.4011 19.0275 94.0873 24.7838 94.0873H83.5362C89.2925 94.0873 93.9775 89.4023 93.9775 83.6423V24.8986C93.9775 19.1411 89.2937 14.4561 83.5362 14.4561ZM70.8887 35.5661C72.8102 35.5661 74.653 36.3294 76.0117 37.6881C77.3704 39.0468 78.1337 40.8896 78.1337 42.8111C78.1337 44.7325 77.3704 46.5753 76.0117 47.934C74.653 49.2927 72.8102 50.0561 70.8887 50.0561C68.9673 50.0561 67.1245 49.2927 65.7658 47.934C64.4071 46.5753 63.6437 44.7325 63.6437 42.8111C63.6437 40.8896 64.4071 39.0468 65.7658 37.6881C67.1245 36.3294 68.9673 35.5661 70.8887 35.5661ZM25.505 28.5061V41.6461H23.54C23.4514 41.6464 23.3636 41.6292 23.2816 41.5955C23.1996 41.5617 23.1251 41.5121 23.0624 41.4495C22.9997 41.3869 22.9499 41.3125 22.9161 41.2306C22.8822 41.1487 22.8648 41.0609 22.865 40.9723V24.0173C22.865 23.4436 23.2925 22.9761 23.88 22.9761H32.5688C33.155 22.9761 33.5837 23.4411 33.5837 24.0148V25.0111H47.0163C47.3913 25.0111 47.6912 25.3123 47.6912 25.6823V29.4948H36.225V28.4973C36.225 27.9236 35.7962 27.4586 35.2075 27.4586H26.5213C25.9338 27.4586 25.5038 27.9323 25.5038 28.5073L25.505 28.5061ZM28.8213 50.2748C28.7327 50.2753 28.6449 50.2583 28.5629 50.2247C28.481 50.1911 28.4065 50.1416 28.3437 50.0791C28.281 50.0166 28.2312 49.9423 28.1973 49.8604C28.1634 49.7786 28.1461 49.6909 28.1463 49.6023V32.6473C28.1463 32.0736 28.5738 31.6061 29.1613 31.6061H37.8475C38.435 31.6061 38.865 32.0723 38.865 32.6448V33.6411H52.2975C52.6712 33.6411 52.9725 33.9423 52.9725 34.3123V49.6036C52.9725 49.692 52.955 49.7796 52.9211 49.8613C52.8871 49.943 52.8373 50.0172 52.7746 50.0795C52.7118 50.1419 52.6374 50.1913 52.5555 50.2248C52.4737 50.2583 52.386 50.2753 52.2975 50.2748H28.8213ZM60.9512 85.7385V63.7261H59.9637L55.4687 70.4336C54.7362 71.4311 53.25 71.9161 52.0662 71.9161H41.5113C40.6694 71.9164 39.8619 71.5824 39.2663 70.9874C38.6706 70.3925 38.3357 69.5854 38.335 68.7435C38.335 66.9948 39.7588 65.6148 41.5113 65.6148H51.1112L57.7712 55.5448C59.3675 53.1098 62.4862 51.9323 64.9987 51.9323L78.0462 51.9248C79.0003 51.9241 79.9451 52.1115 80.8267 52.4761C81.7084 52.8407 82.5095 53.3754 83.1844 54.0497C83.8593 54.724 84.3947 55.5247 84.7601 56.406C85.1255 57.2873 85.3136 58.232 85.3137 59.1861L85.3288 85.7398H60.95L60.9512 85.7385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5598 35.9512H38.5586V39.9499H34.5586V43.9512H38.5586V47.9512H42.5598V43.9512H46.5598V39.9499H42.5598V35.9512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_431_10770",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_431_10770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_431_10770",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_10770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatYouGet4);
export default __webpack_public_path__ + "static/media/WhatYouGet4.81631efac7df80d4c61630e8b71bfc20.svg";
export { ForwardRef as ReactComponent };